<script setup lang="ts">
import { computed } from 'vue'

import { useAdaDynamicSlotMarker } from '../../composables/use-ada-dynamic-slot-marker'

import type { ComposedMetaData } from '@xcel-next/composer-schema'

defineOptions({
  name: 'ParagraphTypeHtml'
})

type HtmlMetaData = ComposedMetaData & {
  seeding?: {
    enabled?: boolean,
    articleId?: string
  }
}

const props = defineProps<{
  html?: string,
  metaData?: HtmlMetaData,
  addCssClass?: string
}>()

useAdaDynamicSlotMarker('')

const seedingArticleId = computed(() => {
  const seeding = props.metaData?.seeding
  return (seeding?.enabled && (seeding.articleId?.length ?? 0) > 0) ? seeding.articleId : undefined
})

const toValidHTML = (html: string): string => {
  // convert incorrect self-closing tags to regular pairs of opening and closing tags
  return html.replace(/<([a-z]*)(\s[^>]*?)?\/>/gi, (complete, tagName: string, attributes = '') => {
    const allowedSelfClosing = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']
    if (!allowedSelfClosing.includes(tagName.toLowerCase())) {
      return `<${tagName}${attributes}></${tagName}>`
    }
    return complete
  })
}

const validHtml = computed(() => {
  const converted = toValidHTML(props.html ?? '')

  // On a privacy page replace [Datenschutzmanager] with a link
  if (props.metaData?.isPrivacyPage === true) {
    const privacyManagerLink = '<a href="javascript:void(0)" onclick="window.openPrivacyManager()">Datenschutzmanager</a>'
    return converted.replace(/\[Datenschutzmanager\]/gi, privacyManagerLink)
  }

  return converted
})
</script>

<template v-if="html?.length">
  <div :id="seedingArticleId"
       class="bx-content bx-content__continuous-text bx-typo--content-continuous-text bx-paragraph-list__html bx-highlight--enabled"
       :class="addCssClass"
       data-tc="html"
       v-html="validHtml" />
</template>
